var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 26H23.83C4.18 24.87 1.39 8.29 1 3.23C0.968579 2.83658 1.01509 2.44082 1.13688 2.06541C1.25866 1.69 1.45333 1.3423 1.70972 1.04225C1.96611 0.7422 2.27919 0.495688 2.63101 0.316839C2.98284 0.137991 3.3665 0.0303218 3.76 9.37591e-07H9.27C9.67056 -0.000386826 10.062 0.119511 10.3936 0.344163C10.7253 0.568815 10.9818 0.88787 11.13 1.26L12.65 5C12.7964 5.36355 12.8327 5.76208 12.7544 6.14609C12.6762 6.5301 12.4869 6.88267 12.21 7.16L10.08 9.31C10.4127 11.2007 11.3182 12.9437 12.6739 14.303C14.0296 15.6622 15.7701 16.5723 17.66 16.91L19.83 14.76C20.1115 14.4862 20.4674 14.3013 20.8533 14.2283C21.2392 14.1554 21.638 14.1977 22 14.35L25.77 15.86C26.1365 16.0129 26.4492 16.2714 26.6683 16.6027C26.8873 16.9339 27.0028 17.3229 27 17.72V23C27 23.7956 26.6839 24.5587 26.1213 25.1213C25.5587 25.6839 24.7957 26 24 26ZM4 2C3.73479 2 3.48043 2.10536 3.2929 2.29289C3.10536 2.48043 3 2.73478 3 3V3.08C3.46 9 6.41 23 23.94 24C24.0714 24.0081 24.2031 23.9902 24.3275 23.9473C24.4519 23.9045 24.5667 23.8374 24.6652 23.7501C24.7637 23.6628 24.8439 23.5568 24.9014 23.4384C24.9588 23.32 24.9924 23.1914 25 23.06V17.72L21.23 16.21L18.36 19.06L17.88 19C9.18 17.91 8 9.21 8 9.12L7.94 8.64L10.78 5.77L9.28 2H4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.345584051684ef46289aa1afdb6b3538.svg";
export { ForwardRef as ReactComponent };